module.exports = __webpack_public_path__ + "img/6.6a6810dd.png";